<template>
  <div class="settings">
    <div class="settings-block">
      <main-text class="settings-subtitle">Структура</main-text>
      <form class="form-grid">
        <custom-checkbox
          class="settings-checkbox"
          :key="structureItem.value"
          v-for="structureItem of structureOptions"
          :value="structure.includes(structureItem.value)"
          @input="handleStructureCheckboxChange(structureItem.value)"
          :labelText="structureItem.text"
          color="secondary"
        />
      </form>
    </div>

    <div class="settings-block">
      <main-text class="settings-subtitle">Поражающие факторы</main-text>

      <form class="form-grid">
        <custom-checkbox
          class="settings-checkbox"
          :key="option.value"
          v-for="option of factorsOptions"
          :value="factors.includes(option.value)"
          @input="handleFactorsCheckboxChange(option.value)"
          :labelText="option.text"
          color="secondary"
        />
      </form>
    </div>

    <div class="settings-block">
      <main-text class="settings-subtitle">Формулы</main-text>

      <form class="form-grid">
        <custom-checkbox
          class="settings-checkbox"
          :key="option.value"
          v-for="option of equationOptions"
          :value="other.includes(option.value)"
          @input="handleOtherCheckboxChange(option.value)"
          :labelText="option.text"
          color="secondary"
        />
      </form>
    </div>

    <div class="settings-block">
      <main-text class="settings-subtitle">Графики</main-text>

      <form class="form-grid">
        <custom-checkbox
          class="settings-checkbox"
          :key="option.value"
          v-for="option of chartsOptions"
          :value="other.includes(option.value)"
          @input="handleOtherCheckboxChange(option.value)"
          :labelText="option.text"
          color="secondary"
        />
      </form>
    </div>

    <div class="settings-block">
      <main-text class="settings-subtitle">Таблицы</main-text>

      <form class="form-grid">
        <custom-checkbox
          class="settings-checkbox"
          :key="option.value"
          v-for="option of tablesOptions"
          :value="other.includes(option.value)"
          @input="handleOtherCheckboxChange(option.value)"
          :labelText="option.text"
          color="secondary"
        />
      </form>
    </div>

    <div class="settings-block">
      <main-text class="settings-subtitle">Другое</main-text>

      <form class="form-grid">
        <custom-checkbox
          class="settings-checkbox"
          :key="option.value"
          v-for="option of otherOptions"
          :value="other.includes(option.value)"
          @input="handleOtherCheckboxChange(option.value)"
          :labelText="option.text"
          color="secondary"
        />
      </form>
    </div>

    <div class="input-file-block">
      <main-text class="settings-subtitle input-file-subtitle">
        Файл отчета пожарного риска в здании в формате *.docx (Fenix+)
      </main-text>

      <div class="file-delete-block" v-if="loadingFile">
        <div>
          <div class="file-delete-name-block">
            <img src="../../files/doc-file-icon.svg" alt="file icon" />
            <p class="file-delete-text">{{ loadingFile.name }}</p>
          </div>
          <p class="file-delete-data">
            {{ loadingFile.size }} Кб, Загружено {{ minutesSinceLastModification }} мин назад
          </p>
        </div>

        <button :disabled="deleting" class="file-delete-button" @click="deleteIntegrate()">
          <img v-if="!deleting" src="../../files/delete-icon.svg" alt="delete icon" />
          <span v-else>Удаление</span>
        </button>
      </div>

      <div class="input-file-wrapper">
        <b-form-file
          drop-placeholder="Перетащите файл сюда"
          @input="integrate()"
          :disabled="integrating"
          class="input-file"
          v-model="file"
        >
          <template slot="placeholder">
            <div class="input-file-placeholder">
              <img src="../../files/file-upload-icon.svg" alt="upload icon" />
              <p class="input-file-text">Перетащите или <span class="selected-text">выберите файл</span></p>
            </div>
          </template>
          <template slot="file-name">
            <div class="input-file-placeholder">
              <p v-if="integrating" class="input-file-text">Загрузка...</p>
            </div>
          </template>
        </b-form-file>
      </div>
    </div>
    <div class="form-button-block">
      <main-button class="form-button" @click="save()"> Сохранить </main-button>

      <main-button @click="$emit('onCancelClick')" color="link">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import MainText from "../../components/ui/Text.vue";
import CustomCheckbox from "../../components/ui/Checkbox.vue";
import MainButton from "../../components/ui/MainButton.vue";

export default {
  name: "reportSettings",
  components: { MainText, CustomCheckbox, MainButton },
  props: {
    project: Object,
    people: Array,
  },

  computed: {
    minutesSinceLastModification() {
      if (!this.loadingFile) return "";
      const timeDifferenceInMilliseconds = new Date().getTime() - this.loadingFile.lastModified;

      return Math.floor(timeDifferenceInMilliseconds / (1000 * 60));
    },
  },

  data() {
    return {
      file: null,
      loadingFile: null,
      factors: [],
      factorsOptions: [
        { text: "Пожар пролива", value: 1 },
        { text: "Волна давления при сгорании паровоздушного облака", value: 2 },
        { text: "Тепловое излучение пожара-вспышки", value: 3 },
        { text: "Образование огненного шара", value: 4 },
        { text: "Струйное горение горизонтального факела", value: 5 },
        { text: "Струйное горение вертикального факела", value: 6 },
        { text: "Взрыв установки с перегретой жидкостью", value: 7 },
      ],
      structure: [],
      structureOptions: [
        { text: "Титульный лист", value: "title" },
        { text: "Оглавление", value: "toc" },
        { text: "Введение", value: "introduction" },
        { text: "Методика", value: "method" },
        { text: "Анализ пожарной опасности", value: "description" },
        { text: "Перечень исходных данных", value: "source" },
        { text: "Результаты проведения расчетов", value: "results" },
        { text: "Вывод", value: "conclusion" },
        { text: "Литература", value: "references" },
      ],
      other: [],
      otherOptions: [
        { text: "Показывать картинки", value: "showPictures" },
        { text: "Не показывать расчеты массы и объема вышедших продуктов", value: "notShowDetailedPrepared" },
        { text: "Не показывать порядок расчёта ОФП", value: "notShowOfpCalc" },
        { text: "Строить графики в отчёте в виде рисунков", value: "pictureCharts" },
        //{text: 'Строить изображения с зонами распространения ОФП', value: 'showOFPZones'},
      ],
      equationOptions: [
        { text: "Не показывать формулы", value: "notShowEquation" },
        { text: "Показывать ссылки на повторяющиеся формулы", value: "repeatedEqLinks" },
      ],
      chartsOptions: [
        { text: "Показывать графики", value: "showCharts" },
        { text: "Показывать графики условных вероятностей поражения", value: "showQdCharts" },
      ],
      tablesOptions: [
        {
          text: "Показывать таблицы с рассчитанными параметрами выхода продуктов при различных инициирующих событиях",
          value: "showPreparedTable",
        },
        { text: "Показывать таблицы с рассчитанными параметрами ОФП на различных расстояниях", value: "showOFPTable" },
      ],
      integrating: false,
      deleting: false,
      showIntegrate: false,
    };
  },

  mounted() {
    if (!this.project.reportConfig || !this.project.reportConfig.factors) {
      for (const factor of this.factorsOptions) {
        this.factors.push(factor.value);
      }
    } else {
      this.factors = this.project.reportConfig.factors;
    }

    if (!this.project.reportConfig || !this.project.reportConfig.structure) {
      for (const factor of this.structureOptions) {
        this.structure.push(factor.value);
      }
    } else {
      this.structure = this.project.reportConfig.structure;
    }

    if (!this.project.reportConfig || !this.project.reportConfig.other) {
      this.other = ["showCharts", "showPictures", "pictureCharts"];
    } else {
      this.other = this.project.reportConfig.other;
    }
  },

  methods: {
    handleStructureCheckboxChange(value) {
      if (this.structure.includes(value)) {
        this.structure = this.structure.filter((item) => item !== value);
      } else {
        this.structure.push(value);
      }
    },

    handleFactorsCheckboxChange(value) {
      if (this.factors.includes(value)) {
        this.factors = this.factors.filter((item) => item !== value);
      } else {
        this.factors.push(value);
      }
    },

    handleOtherCheckboxChange(value) {
      if (this.other.includes(value)) {
        this.other = this.other.filter((item) => item !== value);
      } else {
        this.other.push(value);
      }
    },

    save() {
      this.$http
        .post("projects/report-config-update?id=" + this.project.id, {
          structure: this.structure,
          factors: this.factors,
          other: this.other,
        })
        .then((response) => {
          this.project.reportConfig = response.data;
          this.$emit("hide");
        })
        .catch((e) => {
          alert("Что-то не так", e);
        });
    },

    deleteIntegrate() {
      this.deleting = true;
      this.$http
        .post("projects/report-integrate-remove?proj_id=" + this.project.id)
        .then((response) => {
          this.$emit("update:people", response.data);
          this.project.integration = 0;
          this.showIntegrate = true;
          this.loadingFile = null;
        })
        .catch((e) => {
          alert("Возникла непредвиденная ошибка", e);
        })
        .finally(() => (this.deleting = false));
    },

    integrate() {
      if (!this.file) return;
      const formData = new FormData();
      formData.append("file", this.file);
      this.integrating = true;
      this.$http
        .post("projects/report-integrate?id=" + this.project.id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$emit("update:people", response.data);
          this.project.integration = 1;
          this.showIntegrate = false;
          this.loadingFile = this.file;
        })
        .catch((e) => {
          this.project.integration = 0;

          if (e.response.data.file) {
            alert(e.response.data.file);
          } else {
            alert("Возникла непредвиденная ошибка");
          }
        })
        .finally(() => {
          this.file = null;
          this.integrating = false;
        });
    },
  },
};
</script>

<style scoped>
.settings {
  padding: 0;
}
.settings .settings-subtitle {
  font-weight: 500;
  margin-bottom: 12px;
}
.settings-block {
  padding: 0 24px 24px;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 24px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
  row-gap: 8px;
}
.input-file-block {
  padding: 0 24px 32px;
}
.input-file-wrapper {
  min-height: 56px;
}

.input-file-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
}
.input-file-text {
  font-family: "Ubuntu", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: var(--grey-3-color);
  margin: 0 0 0 12px;
}
.selected-text {
  color: var(--primary-color);
  cursor: pointer;
  pointer-events: all;
}
.input-file-subtitle {
  margin-bottom: 9px;
}
.file-delete-block {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 8px;
  margin-bottom: 8px;
}
.file-delete-name-block {
  display: flex;
  align-items: center;
  gap: 8px;
}
.file-delete-data {
  padding-left: 24px;
  margin: 4px 0 0;
}
.file-delete-button {
  padding: 0;
  background: transparent;
  border: none;
}
.file-delete-text {
  margin: 0;
}
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
